import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "need-support" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col question-icon" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "Need support?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IcoContactSupport = _resolveComponent("IcoContactSupport")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_IcoContactSupport)
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("a", {
          href: `mailto:${_ctx.supportEmail}`
        }, _toDisplayString(_ctx.supportEmail), 9, ["href"])
      ])
    ])
  ]))
}